import { Paragraph, fontWeights, paragraphSizes } from '@va/ui/design-system';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { FilterBlock } from '../../FilterBlock';
import { FilterSelectDropdown } from '../../FilterSelectDropdown';
import { useFiltersContext } from '../../filters-context';
import { SingleSelectFilterInputProps } from './SingleSelectFilterInput';

type SingleSelectFilterInputAppliedProps = {
  disableEditing?: boolean;
  viewOnly?: boolean;
  size?: 'small' | 'medium' | 'large';
  isGrouped?: boolean;
} & SingleSelectFilterInputProps;

export const SingleSelectFilterInputApplied: React.FC<SingleSelectFilterInputAppliedProps> = ({
  useOptions,
  filter,
  showSearchInput = true,
  disableEditing,
  viewOnly,
  isGrouped,
  size = 'large',
}) => {
  const { updateAppliedFilter } = useFiltersContext();

  const { id, label, operator, values, operatorOptions } = filter;

  const { data: options = [] } = useOptions();

  const selectedOption = useMemo(() => options.find((option) => values.includes(option.value)), [options, values]);

  const value = values[0];

  return (
    <FilterBlock
      filterId={id}
      fieldName={label}
      operator={operator}
      operatorOptions={operatorOptions}
      hideDeleteButton={viewOnly}
      disabled={disableEditing}
      size={size}
      isGrouped={isGrouped}
      input={
        <FilterSelectDropdown
          showSearchInput={showSearchInput}
          triggerClassName={classNames('input-wrapper', {
            'bg-transparent!': disableEditing,
          })}
          options={options}
          selectedOptions={!isNil(value) ? { [value]: true } : {}}
          onChange={(option) => {
            updateAppliedFilter(id, { values: [option.value] });
          }}
          disabled={disableEditing}
        >
          <div className='flex items-center gap-2'>
            {selectedOption?.icon}
            <Paragraph size={paragraphSizes.tiny} weight={fontWeights.medium}>
              {selectedOption?.label ?? '-'}
            </Paragraph>
          </div>
        </FilterSelectDropdown>
      }
    />
  );
};
